// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardDiscover-cls1_aGG","cls2":"BigCardDiscover-cls2_nnm BigCardDiscover-cls1_aGG"};